import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Canvas from '../components/Canvas';
import Seed from '../components/Seed';
import QTEBar from '../components/QTEBar';
import GameModel from '../models/GameModel';
import ButtonBack from '../components/ButtonBack';
import backgroundMusic from '../components/music/game.ogg';
import ButtonMute from '../components/ButtonMusic';
import '../App.css';
import ScoreLevel from '../components/ScoreLevel';
import ButtonRetry from '../components/ButtonRetry';
import ButtonFull from '../components/ButtonFull';
import DynamicModal from '../components/DynamicModal';
import NextLevelModal from '../components/ModalNextLevel';
import ModalGameSelesai from '../components/ModalGameSelesai';
import ButtonThrow from '../components/ButtonThrow';
import Tutorial from '../components/ModalTutorial';
import ButtonTanya from '../components/ButtonTanya';
import ModalSoalBekel from "../components/ModalSoalBekel";
import ModalExit from "../components/ModalExit";
import Preloader from '../components/preloader';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";
import ButtonLanguage from '../components/ButtonLanguage';

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const Game = () => {
  const { t } = useTranslation();
  const [modalMessage, setModalMessage] = useState("");
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [showNextLevelModal, setNextLevelModal] = useState(false);
  const [showModalGameSelesai, setModalGameSelesai] = useState(false);
  const [showThrowButton, setShowThrowButton] = useState(true);
  const [isSeedThrown, setIsSeedThrown] = useState(false);
  const [showTutorialModal, setshowTutorialModal] = useState(false);
  const [isModalSoalOpen, setIsModalSoalOpen] = useState(false);
  const [englishscore0, setEnglishScore0] = useState(0);
  const [isAnswer, setIsAnswer] = useState(false);
  const { selectedCategory } = useParams();
  const category = selectedCategory;
  const [showModalExit, setModalExit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(()=>{
    const timer = setTimeout(()=>{
      setIsLoading(false)
    }, 4000);
    return ()=> clearTimeout(timer);
  }, []);

  const handleOpenTutorialModal = () => {
    setshowTutorialModal(true);
  };

  const handleCloseTutorialModal = () => {
    setshowTutorialModal(false);
  };


  const resetButtonThrow = () => {
    setShowThrowButton(true);
    setIsSeedThrown(false);
  };

  const showModalGameComplete = () => {
    setModalGameSelesai(true);
  };

  const showLevelUpModal = (message) => {
    setModalMessage(message);
    setNextLevelModal(true);
  };

  const closeLevelUpModal = () => {
    setNextLevelModal(false);
  };

  const showModal = (message) => {
    setModalMessage(message);
    setShowDynamicModal(true);
  };

  const closeModal = () => {
    setShowDynamicModal(false);
  };

  const showModalSoal = () => {
    setIsModalSoalOpen(true);
  };
  const handleCloseModalSoal = () => {
    setIsModalSoalOpen(false);
  };

  const { gameState, startGame, setBallSpeed, isBallHeld, resetQTE, collectSeed, resetSeed, throwSeed } = GameModel({ showModal, showLevelUpModal, showModalGameComplete, resetButtonThrow, showModalSoal, });
  const [isBallBouncing, setIsBallBouncing] = useState(false);
  const [showRotateMessage, setShowRotateMessage] = useState(false);

  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleMuteToggle = () => {
    console.log('Mute button clicked');
  };

  const onSeedCollect = useCallback(() => {
    collectSeed();
  }, [collectSeed]);

  const onSeedThrow = useCallback(() => {
    throwSeed();
    setIsSeedThrown(true); // Set the state to true when seed is thrown
  }, [throwSeed]);

  useEffect(() => {
    setIsBallBouncing(gameState.ball.dy !== 0 && !gameState.ball.isHeld);
  }, [gameState.ball.dy, gameState.ball.isHeld]);

  const checkOrientation = () => {
    if (window.innerHeight > window.innerWidth) {
      setShowRotateMessage(true);
    } else {
      setShowRotateMessage(false);
    }
  };

  const handleFullscreenChange = () => {
    if (document.fullscreenElement) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Failed to enable fullscreen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error(`Failed to exit fullscreen mode: ${err.message}`);
      });
    }
  };

  useEffect(() => {
    document.title = "Bekel Bounce - Game Play";
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    document.addEventListener('fullscreenchange', handleFullscreenChange);

    try {
      const gameHistory = localStorage.getItem("gameHistory");

      // Debugging - Check what the value of gameHistory is
      console.log("gameHistory:", gameHistory);

      // If localStorage is found and empty, close the modal automatically
      if (!gameHistory || gameHistory.length === 0) {
        setshowTutorialModal(true);
      }
    } catch (error) {
      console.error("Error accessing localStorage:", error);
      setshowTutorialModal(false); // Hide modal if there's an error
    }

    if (document.fullscreenElement) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }

    return () => {
      window.removeEventListener('resize', checkOrientation);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const handleContinueAndCloseModal = () => {
    closeLevelUpModal();
  };

  const handleResetAndCloseModal = () => {
    startGame();
    setEnglishScore0(0);
    closeModal();
  };

  const handleResetAndCloseGameSelesai = () => {
    startGame();
    setEnglishScore0(0);
    setModalGameSelesai(false);
  };

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <div className="game flex relative flex-col items-center justify-center min-h-screen w-full ">
          {showRotateMessage && (
            <div className="rotate-message" id="rotate-message">
              {t("rotate_device")}
            </div>
          )}
          <div className="button-container absolute right-5 z-30 justify-between">
            <div className="right-5 z-30 flex gap-3">
              <ButtonBack setModalExit={setModalExit} score={gameState.score} />
              <audio
                id="background-audio"
                src={backgroundMusic}
                autoPlay
                loop
              />
              <ButtonMute onClick={handleMuteToggle} />
              <ButtonRetry
                onClick={startGame}
                englishscore={setEnglishScore0}
                className="ml-4"
              />
              <ButtonTanya onClick={handleOpenTutorialModal} className="ml-4" />
              <ButtonFull
                isFullscreen={isFullscreen}
                onClick={toggleFullscreen}
                className="top-left-button"
              />
              <ButtonLanguage/>
            </div>
            <div>
              <ScoreLevel
                score={gameState.score}
                level={gameState.levels}
                englishscore={englishscore0}
              />
            </div>
          </div>
          <div className="flex items-center justify-between w-min h-min rounded-lg semuagame">
            <div className="flex items-center gap-5 p-4">
              <div className="flex flex-col items-center mt-6">
                <Seed
                  isBallBouncing={isBallBouncing}
                  onSeedCollect={onSeedCollect}
                  resetSeed={resetSeed}
                  throwSeed={gameState.throwSeed}
                />
                <ButtonThrow
                  show={showThrowButton}
                  onClick={onSeedThrow}
                  isSeedThrown={isSeedThrown}
                />
              </div>
            </div>
            <div className="control flex items-center lg:gap-48 sm:gap-28 md:gap-32 p-4">
              <QTEBar
                setBallSpeed={setBallSpeed}
                isBallHeld={isBallHeld}
                resetQTE={resetQTE}
              />
              <Canvas gameState={gameState} />
            </div>
          </div>
          <ModalSoalBekel
            show={isModalSoalOpen}
            onClose={handleCloseModalSoal}
            setIsAnswer={setIsAnswer}
            SetEnglishScore0={setEnglishScore0}
            Englishscore0={englishscore0}
            selectedTopic={category}
          />
          <DynamicModal
            show={showDynamicModal}
            message={modalMessage}
            score={gameState.score}
            levels={gameState.levels}
            englishscore={englishscore0}
            onReset={handleResetAndCloseModal}
          />
          {isAnswer && (
            <NextLevelModal
              show={showNextLevelModal}
              message={modalMessage}
              levels={gameState.levels}
              onPlayNextLevel={handleContinueAndCloseModal}
            />
          )}
          <ModalGameSelesai
            show={showModalGameSelesai}
            score={gameState.score}
            englishscore={englishscore0}
            onReset={handleResetAndCloseGameSelesai}
            levels={gameState.levels}
            closeModal={() => setModalGameSelesai(false)}
          />
          <ModalExit
            show={showModalExit}
            onClose={() => setModalExit(false)}
            score={gameState.score}
            levels={gameState.levels}
            englishscore={englishscore0}
          />
          <Tutorial
            show={showTutorialModal}
            handleClose={handleCloseTutorialModal}
          />
        </div>
      )}
    </>
  );
};

export default Game;
